import PropTypes from 'prop-types';

// Data about an individual candidate in a race.
const CANDIDATE_SHAPE = {
  electoral_votes: PropTypes.number,
  first_name: PropTypes.string,
  full_name: PropTypes.string,
  image_id: PropTypes.number,
  image_url: PropTypes.string,
  incumbent: PropTypes.bool,
  last_name: PropTypes.string,
  original_full_name: PropTypes.string,
  party_abbreviation: PropTypes.string,
  party_name: PropTypes.string,
  votes_percentage: PropTypes.number,
  votes_total: PropTypes.number,
  winner: PropTypes.bool,
};

// Data common to both race results and ballot measure results.
const COMMON_RESULTS_SHAPE = {
  last_updated: PropTypes.string,
  precincts_percentage: PropTypes.number,
  precincts_reporting: PropTypes.number,
  precincts_total: PropTypes.number,
  subtitle: PropTypes.string,
  suppress_updated: PropTypes.bool,
  title: PropTypes.string,
  total_votes: PropTypes.number,
  type: PropTypes.string,
};

// Data specific to ballot measure results.
const MEASURE_SHAPE = {
  ...COMMON_RESULTS_SHAPE,
  description: PropTypes.string,
  no_percentage: PropTypes.number,
  no_votes: PropTypes.number,
  passed: PropTypes.string,
  yes_percentage: PropTypes.number,
  yes_votes: PropTypes.number,
};

// Data specific to race results.
const RACE_SHAPE = {
  ...COMMON_RESULTS_SHAPE,
  candidates: PropTypes.arrayOf(PropTypes.shape(CANDIDATE_SHAPE)),
  seats: PropTypes.number,
};

// Data specific to group results.
const GROUP_SHAPE = {
  results: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(MEASURE_SHAPE),
      PropTypes.shape(RACE_SHAPE),
    ]),
  ),
  title: PropTypes.string,
  type: PropTypes.string,
};

const GROUP_NAV_SHAPE = {
  results: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(MEASURE_SHAPE),
      PropTypes.shape(RACE_SHAPE),
    ]),
  ),
};

export default {
  GROUP_SHAPE,
  GROUP_NAV_SHAPE,
  CANDIDATE_SHAPE,
  MEASURE_SHAPE,
  RACE_SHAPE,
};
